import React from 'react';


const HourSelector = ({ hours, availableHours, title, setHour, selectedHour, right }) => {
  return (
    <div className={`hours-grid-container ${right ? 'right' : ''}`}>
      <h3>{title}</h3>
      <div className="hour-grid">
        {hours.map((hour) => {
          const isSelected = hour === selectedHour;
          return availableHours.includes(hour) ? (
            <div
              onClick={() => setHour(hour)}
              key={hour}
              className={`available-hour ${isSelected ? 'selected-hour' : ''}`} 
            >
              {`${hour}:00`}
            </div>
          ) : (
            <div key={hour} className="unavailable-hour">
              {`${hour}:00`}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HourSelector;